<div class="w-100 container">
  <!-- ? Header -->
  <app-makna-header
    [title]="'فراموشی رمز عبور'"
    [backUrl]="'login'"
  />

  <!-- ? step content -->
  <div class="content-container w-100">
    <div class="content">
      @switch (activeStep) {
        <!-- ? Insert nationalID -->
        @case (_activeStep.InsertNationalID) {
          @if (!inOTPStep) {
            <app-national-id (formValidation)="onFormValidation($event)" />
          } @else {
            <p class="title-insert-phone">کد ارسال شده به {{ phoneNumber }} را وارد کنید.</p>

            <app-pin-input
              [type]="'OTP'"
              [hasError]="otpHasError"
              [value]="this.otpCode"
              (pinChange)="pinChanged($event)"
              (onRemove)="pinChanged($event)"
            />
            @if (otpHasError) {
              <div class="otp-error">
                <span>{{ otpErrorInfo?.title }}</span>
              </div>
            }
          }
        }
        <!-- ? Generate Password -->
        @case (_activeStep.InsertPassword) {
          <p class="title-insert-phone">برای حساب کاربری خود رمز عبور جدید بسازید.</p>

          <app-password-complexity
            (onPasswordChanged)="onPasswordChanged($event)"
            (onRepeatPasswordChanged)="onRepeatPasswordChanged($event)"
          />
        }
      }
    </div>
    <div class="footer">
      <!-- ? NationalId and OTP -->
      @if (activeStep === _activeStep.InsertNationalID) {
        @if (!inOTPStep) {
          <ngx-button
            [style]="'fill'"
            [brandButton]="true"
            size="medium"
            [fullWidth]="true"
            [disabled]="!nationalIdInfo.isValid || loading"
            (clickHandler)="onNextStep('GET_OTP')"
          >
            تایید و ادامه
          </ngx-button>
        } @else {
          <div class="button-container">
            <!-- ? Timer -->
            <ngx-button
              [style]="'tinted-on-elevated'"
              [fullWidth]="true"
              size="medium"
              [disabled]="!timeIsOver"
              (clickHandler)="onNextStep('GET_OTP')"
            >
              @if (!timeIsOver) {
                <ngx-count-down
                  [timeInSeconds]="otpSecounds"
                  [type]="'mm:ss'"
                  (finished)="timerFinish()"
                ></ngx-count-down>
              } @else {
                <span class="send-again"> ارسال دوباره کد </span>
              }
            </ngx-button>

            <!-- ? Continue -->
            <ngx-button
              [style]="'fill'"
              [fullWidth]="true"
              size="medium"
              [brandButton]="true"
              (clickHandler)="onNextStep('CHECK_OTP')"
              [disabled]="otpCode?.length < 5 || otpHasError || loading || rateLimit"
            >
              ادامه
            </ngx-button>
          </div>
        }
      } @else if (activeStep === _activeStep.InsertPassword) {
        <ngx-button
          [style]="'fill'"
          [brandButton]="true"
          size="medium"
          [fullWidth]="true"
          [disabled]="
            password?.value?.length < 8 ||
            passwordRepeat?.value?.length < 8 ||
            password?.complexity < 2 ||
            passwordRepeat?.complexity < 2 ||
            loading
          "
          (clickHandler)="onNextStep('CREATE_NEW_PASSWORD')"
        >
          @if (rateLimit) {
            <ngx-count-down
              [timeInSeconds]="otpSecounds"
              [type]="'mm:ss'"
              (finished)="timerFinish()"
            ></ngx-count-down>
          } @else {
            <span class="send-again"> تایید و ادامه </span>
          }
        </ngx-button>
      }
    </div>
  </div>
</div>
